export default __webpack_public_path__ + "static/media/Logo.a5e0deca.pdf";